
   <div><app-header ></app-header>
  <div id="wrapper">
  <app-sidebar ></app-sidebar>
  <div id="content-wrapper">
           <div class="container-fluid pb-0 pt-0"> <div class="spacerBlock"></div>
           <div class="row">
            <div class="col-md-12">
<h1>{{feed}}</h1>
  </div>
  </div>
        </div>
        </div>
      </div>
      </div>
   
    